(() => {
  const panelSelector = '[data-ocean-cracking],[data-jsc-cracking]';
  const addSelector = '[data-ocean-cracking-add],[data-cracking-add]';
  const removeSelector = '[data-ocean-cracking-remove],[data-cracking-remove]';
  const confirmSelector = '[data-ocean-cracking-confirm],[data-cracking-confirm]';
  const messageSelector = '[data-ocean-cracking-message],[data-cracking-message]';
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  let restoreLabel = sessionStorage.getItem('cracking-delivery-selection');
  sessionStorage.removeItem('cracking-delivery-selection');
  let restoring = false;
  function reloadCart() {
    const selected=document.querySelector('.bird-method-tab[aria-selected="true"],.identixweb-order-delivery-tablinks[aria-pressed="true"]');
    if(selected) sessionStorage.setItem('cracking-delivery-selection',selected.textContent.trim());
    window.location.reload();
  }
  function deliveryMode() {
    const bird = document.querySelector('.bird-method-tab[aria-selected="true"]');
    if (bird) return /^(local delivery|entrega local|store pickup|store pick-up|in-store pickup|pickup|recogida en tienda|retiro en tienda|recoger en tienda)$/i.test(bird.querySelector('.bird-method-tab__label')?.textContent.trim() || '') ? 'local' : 'other';
    const selected = document.querySelector('.identixweb-order-delivery-tablinks[aria-pressed="true"],.identixweb-order-delivery-tablinks.active');
    if (!selected) return null;
    return selected.classList.contains('local-delivery-identixweb-order-delivery-date') || /^(store pickup|store pick-up|in-store pickup|pickup|recogida en tienda|retiro en tienda|recoger en tienda)$/i.test(selected.textContent.trim()) ? 'local' : 'other';
  }
  function isClaw(item, variant) {
    return item.variant_id !== variant && /\/(?:products\/)?(?:medium-stone-crab|large-stone-crab|large-stone-crab-copia|jumbo-stone-crab-copia|medium-stone-crab-claws|medium-stone-crab-claws-copy|large-stone-crab-claws-copy|colossal-stone-crab-claws)(?:[?/#]|$)/.test(item.url);
  }
  async function request(path, body) {
    const response = await fetch(root + path, body ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)} : {headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('request');
    return response.json();
  }
  function paint(panel) {
    const local = deliveryMode() === 'local';
    const confirm = panel.querySelector(confirmSelector);
    const add = panel.querySelector(addSelector);
    if (confirm) {
      confirm.closest('label').hidden = !local;
      confirm.closest('label').style.setProperty('display',local?'flex':'none','important');
      if (!local) confirm.checked = false;
      confirm.disabled = busy || !local;
    }
    if (add) { add.hidden = !local; add.disabled = busy || !local || !confirm?.checked; }
    const remove = panel.querySelector(removeSelector);
    if (remove) remove.disabled = busy;
    panel.querySelectorAll('[data-cracking-local-hint]').forEach(hint => {hint.hidden = local;});
  }
  async function change(panel, selected) {
    if (busy) return;
    if (selected && (deliveryMode() !== 'local' || !panel.querySelector(confirmSelector)?.checked)) return;
    busy = true; paint(panel);
    const variant = Number(panel.dataset.variant || 67677538222396);
    const message = panel.querySelector(messageSelector);
    try {
      const cart = await request('cart.js');
      if (selected && !cart.items.some(item => isClaw(item, variant))) throw new Error('claws');
      const existing = cart.items.filter(item => item.variant_id === variant);
      const updates = {};
      existing.forEach((item,index) => {updates[item.key] = selected && index === 0 ? 1 : 0;});
      const form = panel.closest('form');
      const attributes = {};
      if (form) new FormData(form).forEach((value,key) => {const match=key.match(/^attributes\[(.+)\]$/);if(match && typeof value==='string') attributes[match[1]]=value;});
      await request('cart/update.js',{updates,attributes,note:form?.querySelector('[name="note"]')?.value ?? cart.note ?? ''});
      if (selected && deliveryMode() !== 'local') {
        const rollback = {};
        existing.forEach(item => {rollback[item.key] = 0;});
        if (existing.length) await request('cart/update.js',{updates:rollback});
      } else if (selected && existing.length === 0) {
        await request('cart/add.js',{items:[{id:variant,quantity:1}]});
      }
      reloadCart();
    } catch(error) {
      message.textContent = error.message === 'claws' ? panel.dataset.clawsError : panel.dataset.error;
      busy = false; paint(panel);
    }
  }
  async function sanitize(panel) {
    if (busy || Number(panel.dataset.quantity) === 0) return;
    if (deliveryMode() === null) return;
    busy = true; paint(panel);
    const variant = Number(panel.dataset.variant || 67677538222396);
    try {
      const cart = await request('cart.js');
      const existing = cart.items.filter(item => item.variant_id === variant);
      const keep = deliveryMode() === 'local' && cart.items.some(item => isClaw(item,variant));
      if (!existing.length || (keep && existing.length === 1 && existing[0].quantity === 1)) {busy=false;paint(panel);return;}
      const updates = {};
      existing.forEach((item,index) => {updates[item.key] = keep && index === 0 ? 1 : 0;});
      await request('cart/update.js',{updates});
      reloadCart();
    } catch(error) {busy=false;paint(panel);panel.querySelector(messageSelector).textContent=panel.dataset.error;}
  }
  let lastState = '';
  function sync(force = false) {
    const panel = document.querySelector(panelSelector);
    if (!panel) {lastState='';return;}
    if (restoring) return;
    if (restoreLabel && deliveryMode() !== null) {
      const target=Array.from(document.querySelectorAll('.bird-method-tab,.identixweb-order-delivery-tablinks')).find(node=>node.textContent.trim()===restoreLabel);
      restoreLabel=null;
      if(target && target.getAttribute('aria-selected')!=='true' && target.getAttribute('aria-pressed')!=='true') {
        restoring=true;target.click();setTimeout(()=>{restoring=false;sync(true);},0);return;
      }
    }
    paint(panel);
    const state = [deliveryMode(),panel.dataset.quantity,panel.dataset.hasClaws].join('|');
    if (force || state !== lastState) {lastState=state;sanitize(panel);}
  }
  document.addEventListener('change', event => {if(event.target.matches(confirmSelector)) sync();});
  document.addEventListener('click', event => {
    const button = event.target.closest(addSelector + ',' + removeSelector);
    if (button) {event.preventDefault();change(button.closest(panelSelector),button.matches(addSelector));}
    const checkout = event.target.closest('[name="checkout"],a[href*="/checkout"],.shopify-payment-button');
    const panel = document.querySelector(panelSelector);
    if (checkout && panel && (busy || (Number(panel.dataset.quantity)>0 && deliveryMode()!=='local'))) {
      event.preventDefault();event.stopImmediatePropagation();sync(true);
    }
  },true);
  document.addEventListener('submit', event => {
    const panel=document.querySelector(panelSelector);
    if (panel && (busy || (Number(panel.dataset.quantity)>0 && deliveryMode()!=='local'))) {event.preventDefault();event.stopImmediatePropagation();sync(true);}
  },true);
  function setup() {
    sync();
    new MutationObserver(records => {
      if(records.some(record => record.type==='childList' || record.target.matches?.('.identixweb-order-delivery-tablinks,.bird-method-tab'))) sync();
    }).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['class','aria-pressed','aria-selected']});
  }
  document.addEventListener('cart-updated',()=>sync(true),true);
  document.addEventListener('krown:cart:update',()=>sync(true));
  document.addEventListener('shopify:section:load',()=>sync(true));
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',setup); else setup();
})();
